/**
 * Browser client for itemiz-core TAP flows via itemiz-it BFF (no API keys in the bundle).
 */
import { authHeaders } from './session.js';

async function parseJson(res) {
  const data = await res.json().catch(() => ({}));
  if (!res.ok) {
    const msg = data.message || data.error || res.statusText || 'Request failed';
    const err = new Error(msg);
    err.status = res.status;
    err.payload = data;
    throw err;
  }
  return data;
}

export async function fetchCoreStatus() {
  const res = await fetch('/api/v1/core/status');
  return parseJson(res);
}

/** TAP 1 — lock receipt to Spanner ledger */
export async function ingestReceipt(receipt) {
  const res = await fetch('/api/v1/core/ingest', {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      merchant_name: receipt.merchant_name,
      total: receipt.total,
      items: receipt.items,
      persona: receipt.persona || '',
    }),
  });
  return parseJson(res);
}

/** TAP 2 — FedNow settle + optional sovereign receipt mint */
export async function settleTransaction(transactionId, receipt) {
  const res = await fetch('/api/v1/core/settle', {
    method: 'POST',
    headers: authHeaders({ 'Content-Type': 'application/json' }),
    body: JSON.stringify({
      transaction_id: transactionId,
      idempotency_key: `IZ-${transactionId}`,
      receipt: receipt
        ? {
            merchant_name: receipt.merchant_name,
            total: receipt.total,
            items: receipt.items,
            persona: receipt.persona || '',
            date: receipt.date,
          }
        : undefined,
    }),
  });
  return parseJson(res);
}

export function receiptToToken(receipt, settleResult) {
  const bankTxId =
    settleResult.column_transfer_id ||
    settleResult.bankTxId ||
    settleResult.bank_tx_id ||
    '—';

  return {
    id: settleResult.transaction_id,
    merchant: receipt.merchant_name,
    date: receipt.date || new Date().toISOString().split('T')[0],
    total: String(receipt.total),
    persona: receipt.persona || '',
    bankTxId,
    verified: true,
    status: settleResult.status || 'VERIFIED_TRUTH',
    sandbox: Boolean(settleResult.sandbox),
    proofUrl: settleResult.proof_of_truth_url || null,
    receiptId: settleResult.receipt_id || null,
    auditSignature: settleResult.audit_signature || settleResult.sovereign?.itemiz_core?.audit_signature || null,
    items: receipt.items.map((i) => ({
      sku: i.sku,
      description: i.description,
      qty: i.quantity,
      unit: i.unit_price,
      total: i.total_price,
    })),
  };
}
